module.exports = __webpack_public_path__ + "static/media/3H.580fd500.svg";